import React, { useState } from "react";

const AgreementModal = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleAgree = () => {
    setIsVisible(false);
    localStorage.setItem("agreementAccepted", "true");
  };

  if (!isVisible || localStorage.getItem("agreementAccepted") === "true") {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">
          📜 网站使用协议 / 风险及合规声明
        </h2>
        <div className="space-y-4 text-gray-700">
          <p>
            尊敬的用户，欢迎使用本平台。为保障所有用户的权益与平台合规运营，请您在使用前务必了解并知悉以下内容：
          </p>

          <div>
            <h3 className="font-semibold">
              一、本平台为合规运营的第三方担保服务机构，秉持底线，以下类型业务一律不予接单：
            </h3>
            <p>
              任何涉及 盗U行为、人口贩卖、毒品交易、枪支弹药、涉恐涉暴
              等违法犯罪内容。
            </p>
            <p>所有涉及 美国地区金流 及 跨链混币、洗币类隐匿行为 的业务。</p>
          </div>

          <div>
            <h3 className="font-semibold">二、平台角色说明：</h3>
            <p>
              本平台所服务的各类群组、频道内的业务行为，均由第三方商户自行提供和开展，我方仅提供中立担保与协调服务。
            </p>
            <p>
              相关业务内容与本平台无直接经营关系，亦不承担实质交易风险责任。
            </p>
          </div>

          <div>
            <h3 className="font-semibold">三、适用地区说明：</h3>
            <p>
              本平台业务仅在 Telegram 平台上开展，Telegram
              目前已被中国大陆地区全面屏蔽，中国大陆用户无法正常访问和使用。
            </p>
            <p>
              因此，平台默认所有客户为非中国大陆用户，如您属特殊地区用户，请自行确保访问行为的合规性与可用性。
            </p>
          </div>
          <div>
            <p>
              ✅
              点击下方【我已知悉】按钮即表示您已理解并接受以上协议内容，本提示将不再重复弹出。
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={handleAgree}
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors"
          >
            我已知悉
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgreementModal;
